import { t } from 'i18next';
import { useCallback, useContext, useMemo } from 'react';

import StatusTabs, { StatusTab } from '~components/Tabs/StatusTabs';

import ApproveChargesPageContext from '../ApproveChargesPageContext';
import {
  CHARGES_VIEW_TABS,
  ChargesViewTab,
  getHighlightedViewTab,
} from '../approveChargesTabs';

const viewTabLabelKeys = {
  [ChargesViewTab.ALL]: 'approvals.approve_charges.view_tabs.all',
  [ChargesViewTab.SETTLED]: 'approvals.approve_charges.view_tabs.settled',
} satisfies Record<ChargesViewTab, string>;

export default function ChargesViewTabs() {
  const { exception, selectViewTab, viewTab } = useContext(ApproveChargesPageContext);

  const tabs = useMemo<StatusTab<ChargesViewTab | null>[]>(
    () =>
      CHARGES_VIEW_TABS.map((tab) => ({
        label: t(viewTabLabelKeys[tab]),
        value: tab,
      })),
    [],
  );

  const handleChange = useCallback(
    (tab: ChargesViewTab | null) => {
      if (tab) {
        selectViewTab(tab);
      }
    },
    [selectViewTab],
  );

  return (
    <StatusTabs
      onChange={handleChange}
      selectedTab={getHighlightedViewTab({ exception, viewTab })}
      tabs={tabs}
    />
  );
}
